import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Features from "./components/Features";
import Plans from "./components/Plans";
import Schedule from "./components/Schedule";
import ParkingCalendar from "./components/ParkingCalendar";
import Flow from "./components/Flow";
import MapSection from "./components/MapSection";
import FAQ from "./components/FAQ";
import ReserveForm from "./components/ReserveForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-w-0 bg-background-50 text-foreground-950 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Features />
        <Plans />
        <Schedule />
        <ParkingCalendar />
        <Flow />
        <MapSection />
        <FAQ />
        <ReserveForm />
      </main>
      <Footer />
    </div>
  );
}